import { actions as simpleActions } from '../slice';

import * as initActions from './init';

export const actions = { ...initActions, ...simpleActions };
